import(/* webpackMode: "eager" */ "/opt/build/repo/packages/frontend/frontend/app/[locale]/[[...slug]]/not-found.tsx");
